import React from 'react';

import classes from './BuildControls.module.css';
import BuildControl from './BuildControl/BuildControl';

const controls = [
    { label: 'Salad', type: 'salad' },
    { label: 'Bacon', type: 'bacon' },
    { label: 'Cheese', type: 'cheese' },
    { label: 'Meat', type: 'meat' },
];

const buildControls = props => (
    <div className={classes.buildControls}>
        <p>Current Price: <strong>${props.price.toFixed(2)}</strong></p>
        {controls.map(c => {
            return <BuildControl
                key={c.label}
                label={c.label}
                added={props.addIngredient.bind(this, c.type)}
                removed={props.removeIngredient.bind(this, c.type)}
                disabled={props.disabledInfo[c.type]} />
        })}
        <button className={classes.orderButton} disabled={!props.purchasable} onClick={props.purchase}>{props.isAuthenticated ? 'Order Now' : 'Sign Up to Continue'}</button>
    </div>
);

export default buildControls;